import script from "./YearEndOfferBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./YearEndOfferBanner.vue?vue&type=script&setup=true&lang=js"

import "./YearEndOfferBanner.vue?vue&type=style&index=0&id=10137eff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10137eff"]])

export default __exports__